// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class ReminderUserSettingsRecordDataProjectSummary {
  readonly id: string;
  readonly name: string;
  readonly bidDate: DateTime | null;
  readonly expirationDate: DateTime | null;
  readonly estimatedStartDate: DateTime | null;
  readonly estimatedEndDate: DateTime | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.bidDate = DateHelpers.ParseServerNullableDate(data.bidDate);
    this.expirationDate = DateHelpers.ParseServerNullableDate(data.expirationDate);
    this.estimatedStartDate = DateHelpers.ParseServerNullableDate(data.estimatedStartDate);
    this.estimatedEndDate = DateHelpers.ParseServerNullableDate(data.estimatedEndDate);
  }

  static zero(): ReminderUserSettingsRecordDataProjectSummary {
    const zeroValues: ExcludeMethodsDeep<ReminderUserSettingsRecordDataProjectSummary> = {
      id: NIL_UUID,
      name: '',
      bidDate: null,
      expirationDate: null,
      estimatedStartDate: null,
      estimatedEndDate: null,
    };
    return new ReminderUserSettingsRecordDataProjectSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ReminderUserSettingsRecordDataProjectSummaryWireFormat = {
  id: string;
  name: string;
  bidDate: string | null;
  expirationDate: string | null;
  estimatedStartDate: string | null;
  estimatedEndDate: string | null;
};

type NewReminderUserSettingsRecordDataProjectSummaryProps = PartialDeep<
  ReminderUserSettingsRecordDataProjectSummary,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataProjectSummary: (
  props: NewReminderUserSettingsRecordDataProjectSummaryProps,
) => ReminderUserSettingsRecordDataProjectSummary = (props) =>
  new ReminderUserSettingsRecordDataProjectSummary(props);

type NewReminderUserSettingsRecordDataProjectSummaryFromWireFormatProps = PartialDeep<
  ReminderUserSettingsRecordDataProjectSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewReminderUserSettingsRecordDataProjectSummaryFromWireFormat: (
  props: NewReminderUserSettingsRecordDataProjectSummaryFromWireFormatProps,
) => ReminderUserSettingsRecordDataProjectSummary = (props) =>
  new ReminderUserSettingsRecordDataProjectSummary(props);
